export default "__VITE_ASSET__f0e5903f__"